import { IntentMutation, useDeclareIntent } from '@imago/api-client-for-react'
import { IntentRequest, IntentRequestToIntent } from "@imago/model"
import { api } from "./_imago_api.ts"

export async function declareIntent<TIntentRequest extends IntentRequest>(request: TIntentRequest): Promise<IntentRequestToIntent<TIntentRequest>> {
	return await api.post('intents/', {
		json: request,
	}).json()
}

export interface ImagoIntentMutation<TIntentRequest extends IntentRequest> extends IntentMutation<IntentRequestToIntent<TIntentRequest>> {
	request: TIntentRequest
}

export function useDeclareImagoIntent<TIntentRequest extends IntentRequest>(request: TIntentRequest): ImagoIntentMutation<TIntentRequest> {
	return {
		request,
		...useDeclareIntent(() => declareIntent(request))
	}
}
